<template>
  <svg class="card-illo" viewBox="0 0 240 135" preserveAspectRatio="xMidYMid meet" v-if="type === 'Guide'">
    <path d="M120 34 L120 108" stroke="#0a0a0a" stroke-width="2"/>
    <path d="M120 34C104 26 78 24 58 30 L58 100C78 94 104 96 120 104Z" fill="#ffffff" stroke="#0a0a0a" stroke-width="2"/>
    <path d="M120 34C136 26 162 24 182 30 L182 100C162 94 136 96 120 104Z" fill="#ffffff" stroke="#0a0a0a" stroke-width="2"/>
    <line x1="68" y1="46" x2="108" y2="42" stroke="#e1e1e0" stroke-width="3"/>
    <line x1="68" y1="58" x2="108" y2="54" stroke="#e1e1e0" stroke-width="3"/>
    <line x1="68" y1="70" x2="100" y2="67" stroke="#e1e1e0" stroke-width="3"/>
    <line x1="132" y1="42" x2="172" y2="46" stroke="#e1e1e0" stroke-width="3"/>
    <line x1="132" y1="54" x2="172" y2="58" stroke="#e1e1e0" stroke-width="3"/>
    <line x1="132" y1="67" x2="164" y2="70" stroke="#e1e1e0" stroke-width="3"/>
    <path d="M100 20 L100 44 L108 38 L116 44 L116 20Z" fill="#bdd38a" stroke="#0a0a0a" stroke-width="2"/>
  </svg>

  <svg class="card-illo" viewBox="0 0 240 135" preserveAspectRatio="xMidYMid meet" v-else-if="type === 'Blog Article'">
    <path d="M40 108 L200 108 L188 118 L52 118Z" fill="#e1e1e0" stroke="#0a0a0a" stroke-width="2"/>
    <rect x="55" y="24" width="130" height="80" rx="6" fill="#ffffff" stroke="#0a0a0a" stroke-width="2"/>
    <circle cx="72" cy="40" r="8" fill="#afd6ea" stroke="#0a0a0a" stroke-width="1.5"/>
    <line x1="86" y1="37" x2="130" y2="37" stroke="#0a0a0a" stroke-width="2"/>
    <line x1="86" y1="45" x2="116" y2="45" stroke="#dfdbd9" stroke-width="2"/>
    <line x1="70" y1="58" x2="170" y2="58" stroke="#e1e1e0" stroke-width="3"/>
    <line x1="70" y1="68" x2="170" y2="68" stroke="#e1e1e0" stroke-width="3"/>
    <line x1="70" y1="78" x2="150" y2="78" stroke="#e1e1e0" stroke-width="3"/>
    <line x1="70" y1="88" x2="160" y2="88" stroke="#e1e1e0" stroke-width="3"/>
  </svg>

  <svg class="card-illo" viewBox="0 0 240 135" preserveAspectRatio="xMidYMid meet" v-else-if="type === 'Case Study'">
    <line x1="50" y1="110" x2="200" y2="110" stroke="#0a0a0a" stroke-width="2"/>
    <rect x="64" y="82" width="24" height="28" fill="#dfdbd9"/>
    <rect x="100" y="66" width="24" height="44" fill="#c9c5c2"/>
    <rect x="136" y="46" width="24" height="64" fill="#0a0a0a"/>
    <path d="M64 78 L100 60 L136 40 L172 24" fill="none" stroke="#463dfb" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M160 24 L172 24 L172 36" fill="none" stroke="#463dfb" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

  <svg class="card-illo" viewBox="0 0 240 135" preserveAspectRatio="xMidYMid meet" v-else-if="type === 'Template'">
    <rect x="30" y="18" width="180" height="100" rx="10" fill="#ffffff" stroke="#0a0a0a" stroke-width="2"/>
    <circle cx="44" cy="31" r="3" fill="#0a0a0a" opacity="0.25"/>
    <circle cx="55" cy="31" r="3" fill="#0a0a0a" opacity="0.25"/>
    <circle cx="66" cy="31" r="3" fill="#0a0a0a" opacity="0.25"/>
    <line x1="30" y1="40" x2="210" y2="40" stroke="#eae6e4" stroke-width="2"/>
    <rect x="46" y="52" width="148" height="26" rx="4" fill="#f391ad"/>
    <rect x="46" y="86" width="120" height="6" rx="3" fill="#e1e1e0"/>
    <rect x="46" y="98" width="90" height="6" rx="3" fill="#e1e1e0"/>
    <rect x="46" y="110" width="52" height="10" rx="5" fill="#0a0a0a"/>
  </svg>

  <svg class="card-illo" viewBox="0 0 240 135" preserveAspectRatio="xMidYMid meet" v-else-if="type === 'Webinar'">
    <rect x="55" y="26" width="130" height="82" rx="8" fill="#ffffff" stroke="#0a0a0a" stroke-width="2"/>
    <path d="M170 50 C180 58 180 76 170 84" fill="none" stroke="#afafae" stroke-width="3" stroke-linecap="round"/>
    <path d="M178 42 C194 56 194 78 178 92" fill="none" stroke="#afafae" stroke-width="3" stroke-linecap="round"/>
    <circle cx="120" cy="67" r="26" fill="#0a0a0a"/>
    <path d="M112 55 L134 67 L112 79Z" fill="#ffffff"/>
    <rect x="63" y="34" width="42" height="14" rx="7" fill="#f53106"/>
    <text x="68" y="44" font-family="Arial, sans-serif" font-size="10" font-weight="700" fill="#ffffff">LIVE</text>
  </svg>

  <svg class="card-illo" viewBox="0 0 240 135" preserveAspectRatio="xMidYMid meet" v-else-if="type === 'eBook'">
    <rect x="80" y="20" width="80" height="100" rx="4" fill="#ffffff" stroke="#0a0a0a" stroke-width="2"/>
    <line x1="92" y1="20" x2="92" y2="120" stroke="#0a0a0a" stroke-width="2"/>
    <rect x="100" y="34" width="48" height="6" rx="3" fill="#e1e1e0"/>
    <rect x="100" y="46" width="36" height="6" rx="3" fill="#e1e1e0"/>
    <rect x="100" y="60" width="48" height="38" rx="3" fill="#afd6ea"/>
    <circle cx="150" cy="104" r="17" fill="#0a0a0a"/>
    <path d="M150 96v14M144 105l6 7 6-7" stroke="#ffffff" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

  <svg class="card-illo" viewBox="0 0 240 135" preserveAspectRatio="xMidYMid meet" v-else>
    <path d="M120 30 L120 100" stroke="#0a0a0a" stroke-width="2"/>
    <path d="M120 30C104 22 78 20 60 26 L60 96C78 90 104 92 120 100Z" fill="#ffffff" stroke="#0a0a0a" stroke-width="2"/>
    <path d="M120 30C136 22 162 20 180 26 L180 96C162 90 136 92 120 100Z" fill="#ffffff" stroke="#0a0a0a" stroke-width="2"/>
    <text x="74" y="62" font-family="Georgia, serif" font-size="24" font-weight="700" fill="#191919">A</text>
    <text x="142" y="60" font-family="Georgia, serif" font-size="17" font-weight="700" fill="#191919">z</text>
    <line x1="68" y1="74" x2="104" y2="72" stroke="#e1e1e0" stroke-width="3"/>
    <line x1="136" y1="72" x2="168" y2="74" stroke="#e1e1e0" stroke-width="3"/>
    <circle cx="166" cy="92" r="13" fill="none" stroke="#0a0a0a" stroke-width="3"/>
    <line x1="175" y1="101" x2="187" y2="113" stroke="#0a0a0a" stroke-width="4" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: "CardIllustration",
  props: {
    type: {
      type: String,
      required: true,
    },
  },
};
</script>
